interface ListState<T> {
  loading: boolean
  loadingState: boolean
  data?: T[]
  items?: T[]
  page?: number
  totalPages?: number
  totalItems?: number
}

interface ObjectState<T> {
  loading: boolean
  loadingState: boolean
  data: T
}

interface User {
  id?: string
  name?: string
  email?: string
}

interface RootState {
  user: ObjectState<User>
  categories: ListState<any>
  products: ListState<any>
  banners: ListState<any>
  matches: ListState<any>
  termsAndConditions: ObjectState<any>
  privacyPolicy: ObjectState<any>
  aboutUs: ObjectState<any>
  adminRules: ListState<any>
  playerRules: ListState<any>
  users: ListState<any>
  inidividualUser: ObjectState<any>
  transactions: ListState<any>
  matchJoinedBy: ListState<any>
  paymentSetting: ObjectState<any>
  orders: ListState<any>
  tickets: ListState<any>
  dashboard: ObjectState<any>
  reportReason: ListState<any>
  pushNotification: ListState<any>
  notifications: ListState<any>
  subadmin: ListState<any>
  screenshot: ListState<any>
  maintainanceMode: ObjectState<any>
  appMode: ObjectState<any>
  platformCharge: ObjectState<any>
  appSettings: ListState<any>
  smmCuratedServices: ListState<any>
  aluuCuratedProducts: ListState<any>
  smmOrders: ListState<any>
  aluuOrders: ListState<any>
}

const initialState: RootState = {
  user: {
    loading: true,
    loadingState: true,
    data: {},
  },
  categories: {
    loading: true,
    loadingState: true,
    data: [],
  },
  products: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  banners: {
    loading: true,
    loadingState: true,
    data: [],
  },
  matches: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  matchJoinedBy: {
    loading: true,
    loadingState: true,
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  termsAndConditions: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  aboutUs: {
    loading: true,
    loadingState: true,
    data: {},
  },
  adminRules: {
    loading: true,
    loadingState: true,
    data: [],
  },
  playerRules: {
    loading: true,
    loadingState: true,
    data: [],
  },
  users: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  inidividualUser: {
    loading: true,
    loadingState: true,
    data: {},
  },

  transactions: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  paymentSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  orders: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  tickets: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  dashboard: {
    loading: true,
    loadingState: true,
    data: {},
  },
  reportReason: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  pushNotification: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  notifications: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  subadmin: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  screenshot: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  maintainanceMode: {
    loading: true,
    loadingState: true,
    data: {},
  },
  appMode: {
    loading: true,
    loadingState: true,
    data: {},
  },
  platformCharge: {
    loading: true,
    loadingState: true,
    data: {},
  },
  appSettings: {
    loading: true,
    loadingState: true,
    data: [],
  },
  smmCuratedServices: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  aluuCuratedProducts: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  smmOrders: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  aluuOrders: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
}

export default initialState
